<template>
    <div class="bottom-btn">
        <div class="bottom-btn-bd t-disabled">提交</div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import '@mobileAssets/styles/pages/AIContest/widgets/bottom-btn.scss';
</style>
